// extracted by mini-css-extract-plugin
export var body = "_mn-8";
export var button = "_mn-0";
export var closeButton = "_mn-5";
export var content = "_mn-3";
export var empty = "_mn-f";
export var grid = "_mn-c";
export var header = "_mn-4";
export var icon = "_mn-1";
export var option = "_mn-d";
export var optionSelected = "_mn-e";
export var overlay = "_mn-2";
export var searchIcon = "_mn-a";
export var searchInput = "_mn-b";
export var searchWrapper = "_mn-9";
export var title = "_mn-6";
export var visuallyHidden = "_mn-7";